<template>
  <div class="test-container">

    <el-button type="primary" @click="Dialog = true">输入</el-button>

    <ots-custom-dialog :dialog.sync="Dialog" title="输入" width="50%">
      <template v-slot:content>
        <slot>
          <ots-editor v-model="val" class=".editor"/>
        </slot>
      </template>
      <template v-slot:footer>
        <el-button round @click="Dialog = false">取消</el-button>
        <el-button type="primary" round @click="send()">确定</el-button>
      </template>
    </ots-custom-dialog>

    <ots-table-group-new
      :tableHeader="tableHeader"
    >
    </ots-table-group-new>

  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  name: 'test',
  components: { VueUeditorWrap },

  data() {
    return {
      val: '',
      back: '',
      Dialog: false,
      tableHeader: [
        {
          title: "批次状态",
          prop: "planState",
          fixed: "left",
        },
        {
          title: "姓名",
          prop: "realName",
          fixed: "left",
        },
        {
          title: "性别",
          prop: "sex",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "手机号",
          prop: "phone",
        },
      ],
    }
  },
  methods: {
    send () {
      console.log(this.val)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/style/ueditor/css/ueditor.css";

.test-container {
  padding: 50px;
  .editor {
    width: 100%;
  }
}

</style>


